// extracted by mini-css-extract-plugin
export default {"pieButton":"PieButton_pieButton__6Zzba","value":"PieButton_value__iZ4Xv","value2":"PieButton_value2__6RjX+","background":"PieButton_background__pcoML"};